import type { ComponentProps, MouseEvent, ReactElement } from "react";

import { Tooltip } from "@similarweb/ui-components";

import useIsTruncatedElement from "./hooks/useIsTruncatedElement";
import TruncatedText from "./TruncatedText";

const DEFAULT_TOOLTIP_DELAY = 200;

interface ITruncatedTooltipProps extends Omit<ComponentProps<typeof TruncatedText>, "labelRef"> {
    tooltipDelay?: number;
}

const TruncatedTextWithTooltip = ({
    tooltipDelay = DEFAULT_TOOLTIP_DELAY,
    children,
    onMouseEnter,
    ...props
}: ITruncatedTooltipProps): ReactElement => {
    const { ref, isTruncated, recalculate } = useIsTruncatedElement<HTMLSpanElement>();

    const handleMouseEnter = (e: MouseEvent<HTMLSpanElement>) => {
        recalculate();

        onMouseEnter?.(e);
    };

    return (
        <Tooltip
            delay={tooltipDelay}
            content={children}
            enabled={isTruncated}
        >
            <TruncatedText
                {...props}
                labelRef={ref}
                onMouseEnter={handleMouseEnter}
            >
                {children}
            </TruncatedText>
        </Tooltip>
    );
};

export default TruncatedTextWithTooltip;
